import { HEADER_INFO, HEADER_MAP, HEADER_MEDIA } from './headerPaths';

export const AREA_BASE = '/area';

export const AREA_MAP = AREA_BASE + HEADER_MAP;
export const AREA_DATA = AREA_BASE + HEADER_INFO;
export const AREA_MEDIA = AREA_BASE + HEADER_MEDIA;
